// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"321d650e97172b625862","243":"307c1cf31df043fbcfea","595":"f7776ac79a7da92f941a","658":"d696aa849c3f58494346","871":"6df456c8ecfcbe410a7e"}[chunkId] + ".bundle.js";
};